import classNames from 'classnames'
import React from 'react'

import Icon, {Icons} from '../../icons/Icon'

interface LeadingComponentProps {
  leadingIcon?: Icons;
  disabled?: boolean;
  className?: string;
}

const LeadingComponent = ({
  leadingIcon,
  disabled = false,
  className = ''
}: LeadingComponentProps) => {
  if (!leadingIcon) return null

  const leadingIconWrapperClassNames = classNames(
    'absolute inset-y-0 flex items-center pointer-events-none left-3',
    {
      'fill-kwota-neutral-600': !disabled,
      'fill-kwota-neutral-400': disabled
    }, className
  )

  return (
    <div className={leadingIconWrapperClassNames}>
      <Icon icon={leadingIcon} className="fill-inherit" />
    </div>
  )
}

export default LeadingComponent
